<app-modal
  [title]="'EC terminal actions' | trans:'extras/ec-terminal-actions-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div class="d-grid gap-12">
      <button
        class="button button--quick-action"
        [disabled]="isEcStandalone"
        (click)="reconnectEcTerminal()"
      >
        <i class="ri-refresh-line"></i>
        {{ 'EC-Terminal neu verbinden' | trans:'extras/ec-terminal-actions-modal/buttons/reconnectEcTerminal.Button' }}
      </button>

      <button
        class="button button--quick-action"
        [disabled]="!isEcPrintLocationPos || isEcStandalone"
        (click)="printEcReceipt()"
      >
        <i class="icon-webcash_tse-online"></i>
        {{ 'EC-Bon drucken' | trans:'extras/ec-terminal-actions-modal/buttons/printEcReceipt.Button' }}
      </button>

      <button
        class="button button--quick-action"
        [disabled]="isEcStandalone"
        (click)="endOfDay()"
      >
        <i class="icon-webcash_tse-online"></i>
        {{ 'EC-Kassenschitt drucken' | trans:'extras/ec-terminal-actions-modal/buttons/printEcCashRegisterReceipt.Button' }}
      </button>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'extras/ec-terminal-actions-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-ec-terminal-action-logs-modal />
